import { MaybeRef } from 'vue'
import { CustomFieldTypeValueInput, RateType } from '@/gql/graphql'
import { useJobRateCardBandQuery } from '@/components/Job/composables/useJobRateCardBandQuery'

// For the two supplier-leg surfaces only — always sends rate/rateType, unlike useRateCardBand.
// Reads the band stored on the source job, not today's card.
export function useSupplierRateCardBand(options: {
  jobId: MaybeRef<string | undefined>
  customFieldValues: MaybeRef<CustomFieldTypeValueInput[] | undefined>
  rate: MaybeRef<string | number>
  rateType: MaybeRef<RateType>
  enabled: MaybeRef<boolean>
}) {
  return useJobRateCardBandQuery({ ...options, cached: true })
}
